module.exports = __webpack_public_path__ + "img/link-arrow-rw-hover.885bd2b3.svg";